module.exports = __webpack_public_path__ + "static/img/as.16f433a6.svg";